import React from "react";
import { alterImageUrl } from "config/calculations/calculation";

const chasePosition = {
  center: "absolute z-10",
  right: "",
  // right: "absolute right-[-172px]",
  left: "",
};

function Chase(props) {
  const {
    chase_color,
    height,
    chase_position,
    background_image,
    dragEntered,
    serv,
  } = props;
  return (
    <>
      <div
        id="infinity_chase"
        className={` chase_outer z-10 ${chasePosition[chase_position]}`}
        style={{ height: `${height}px` }}
      >
        <div
          className={`h-full chase_inner ${
            dragEntered &&
            serv?.service?.mount_type === "direct" &&
            "chase_compartment"
          } `}
          // style={{
          //   backgroundColor: chase_color,
          //   backgroundImage: `url(${alterImageUrl(background_image)})`,
          // }}
        >
          <div
            className={`w-[189.821428571px] grain  h-full ${
              dragEntered &&
              serv?.service?.mount_type === "direct" &&
              "non_dropable_chase"
            }`}
            style={{
              backgroundColor: chase_color,
              backgroundImage: `url(${alterImageUrl(background_image)})`,
            }}
          />
        </div>
      </div>
    </>
  );
}

export default Chase;
